<div class="csv-upload-container">
    <app-header-content-help-text [Heading]="'Refresh Forecast Upload'" [helpText]="'Upload a CSV file using drag and drop or file picker'"></app-header-content-help-text>

    <div *ngIf="!file" class="upload-dropzone" [class.is-dragging]="isDragging" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <input #fileInput class="file-input" type="file" accept=".csv,text/csv" (change)="onFileSelected($event)">
        <div class="dropzone-content">
            <svg xmlns="http://www.w3.org/2000/svg" class="upload-icon" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <path d="M12 18v-6"></path>
                <polyline points="9 15 12 12 15 15"></polyline>
            </svg>
            <p class="dropzone-text">Drag and drop your CSV file here</p>
            <button type="button" mat-flat-button color="primary" (click)="fileInput.click()">Choose CSV</button>
            <p class="hint-text">Only `.csv` files are accepted</p>
        </div>
    </div>

    <p *ngIf="errorMessage" class="error-text">{{ errorMessage }}</p>

    <div *ngIf="file" class="file-summary">
        <div class="file-card">
            <div class="file-meta">
                <span class="meta-label">File name</span>
                <span class="meta-value">{{ file.name }}</span>
            </div>
            <div class="file-meta">
                <span class="meta-label">Size</span>
                <span class="meta-value">{{ formatFileSize(file.size) }}</span>
            </div>
        </div>

        <div class="actions-row">
            <button type="button" mat-stroked-button color="warn" (click)="removeFile()" [disabled]="isUploading">Remove</button>
            <button type="button" mat-flat-button color="primary" (click)="uploadFile()" [disabled]="isUploading">
                <span *ngIf="!isUploading">Upload</span>
                <span *ngIf="isUploading">Preparing...</span>
            </button>
        </div>
    </div>
</div>
